<template>
	<div class="main_left">
		<ul class="menu_list">
			<li class="item" v-for="(item,index) in leftMenu" @click.stop="tabMenu(item.resourceId)" :key="index" :class="{active:leftMenuIndex == item.resourceId}">
				<p class="txt pointer">
					<i class="iconfont">&#xe73a;</i>
					<span class="name">{{item.resourceName}}</span>
				</p>
				<i class="sj"></i>
				<div class="child" v-if="item.children.length>0" v-show="leftMenuIndex==item.resourceId">
					<router-link :to="citem.resourceHref" class="ctxt" v-for="(citem,ckey) in item.children" :key="ckey" @click.native="setMenuIndex(item.resourceId,citem.resourceId)"> - {{citem.resourceName}}</router-link>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	props:{
    leftMenu:{
      type:Array,
      default:()=>{
        return [];
      }
    },
    leftMenuIndex:Number
	},
	data() {
		return {
      itemIndex:0
		};
	},
	created(){

	},
  watch:{
    "$route":{
      handler:function(to, from){

      },
      // 深度观察监听
      deep: true
    }
  },
  computed:{

  },
	methods: {
		//左侧切换菜单
		tabMenu(index){
      this.$emit('setLeftMenuIndex',index);
		},
    //设置菜单索引
    setMenuIndex(leftIndex,thisId){
      console.log(0,'====565646==')
      this.$store.state.account.leftMenuIndex = leftIndex;
      this.$store.state.account.leftChildMenuIndex = thisId;

      localStorage.getItem('leftMenuIndex',leftIndex);
      localStorage.getItem('leftChildMenuIndex',thisId);

      console.log(leftIndex,thisId,'=  索引 ==');
    }

    //获取左侧菜单索引
  /*  leftIndex(){
      let thisRoute = this.$route.path;
      let leftIndex = 0;
      this.leftMenu.forEach((item,index)=>{
        let Obj = item.children.findIndex(v=>v.resourceHref === thisRoute);
        if(Obj != -1) leftIndex = index;
      });
      this.itemIndex = leftIndex;
      console.log(this.$route,'====',this.leftMenu,leftIndex,'----');
    }, */
	}
}
</script>

<style lang="stylus" scoped>
	.el-menu-vertical-demo
		&:not(.el-menu--collapse)
			width 200px
			min-height 400px

</style>
